import fp from 'lodash/fp'
import { autorun } from 'mobx'
import { useEffect, useRef } from 'react'

const getDeps = (source, depsNames) =>
  Array.isArray(depsNames)
    ? depsNames.map((dep) => fp.get(dep, source))
    : depsNames

export const withMobxAutorun = (fn, deps) => (state, props) => {
  const firstRunRef = useRef(true)

  useEffect(
    () =>
      autorun((computation) => {
        fn({ state, props, computation, firstRun: firstRunRef.current })
        firstRunRef.current = false
      }),
    getDeps({ ...state, ...props }, deps)
  )
}
